module.exports = __webpack_public_path__ + "img/dwarf_15.84c612d0.png";